import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { List, Map } from 'immutable';

import {
  ContainedTypeAndId,
  containerKey,
} from '®shared/container-structure/state';
import { EditableSection } from '®shared/reading-list/models';

/**
 * Component for a table-of-contents dropdown
 */
@Component({
  selector: 'rl-table-of-contents',
  templateUrl: './table-of-contents.component.html',
})
export class TableOfContentsComponent implements OnChanges {
  @Input() containerRoot: ContainedTypeAndId;
  @Input() containerStructure: Map<string, List<ContainedTypeAndId>>;
  @Input() sectionsById: Map<string, EditableSection>;
  @Input() disabled = false;

  sections: List<ContainedTypeAndId>;

  ngOnChanges(changes?: SimpleChanges) {
    if (
      changes &&
      (changes['containerRoot'] || changes['containerStructure'])
    ) {
      const children = this.containerStructure.get(
        containerKey(this.containerRoot),
      );
      this.sections = children
        ? children.filter(child => child.type === 'sections')
        : List();
    }
  }
}
